import { render, staticRenderFns } from "./ChangeRequest.html?vue&type=template&id=4d0d2814&external"
import script from "./ChangeRequest.js?vue&type=script&lang=js&external"
export * from "./ChangeRequest.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports